/**
 * ErrorFallback - User-friendly error fallback with reload button
 * Used by ErrorBoundary when no custom fallback is provided
 */

import { Button } from "./ui/button";

export interface ErrorFallbackProps {
  error?: Error | null;
  onReset?: () => void;
}

export function ErrorFallback({ error, onReset }: ErrorFallbackProps) {
  return (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center bg-background p-4"
    >
      <div className="max-w-md w-full text-center">
        <div className="w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center mx-auto mb-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-destructive"
          >
            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
            <path d="M12 9v4" />
            <path d="M12 17h.01" />
          </svg>
        </div>

        <h1 className="text-xl font-semibold mb-2">
          Ein Fehler ist aufgetreten
        </h1>
        <p className="text-muted-foreground mb-6">
          Ein unerwarteter Fehler ist aufgetreten. Bitte laden Sie die Seite neu.
        </p>

        {error && (
          <details className="text-left mb-6">
            <summary className="text-xs text-muted-foreground cursor-pointer">
              Technische Details
            </summary>
            <pre className="text-xs bg-muted p-3 rounded-lg mt-2 overflow-auto max-h-32">
              {error.message}
            </pre>
          </details>
        )}

        <div className="flex gap-3 justify-center">
          <Button
            onClick={() => {
              onReset?.();
              window.location.reload();
            }}
          >
            Seite neu laden
          </Button>
        </div>
      </div>
    </div>
  );
}
